import { FinishRegisterUserCommand, LocalizedLinkDisplayModel } from '@/api/model-index';
import { AccessToken } from '@/core/models/access-token.model';
import { IdToken } from '@/core/models/id-token.model';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { JwtHelperService } from '@auth0/angular-jwt';
import { finalize, map } from 'rxjs/operators';
import { PasswordValidator } from '../../validators/password.validator';
import { PasswordMatchValidator } from '../../validators/passwordmatch.validator';
import { RegisterComponent } from '../register/register.component';
import { emailValidator } from '@/core/validators/customform.validators';
import { UserFriendlyException } from '@/core/utils/notifications/user-friendly-exception.notification';

@Component({
    selector: 'finish-register',
    templateUrl: './finish-register.component.html',
    styleUrls: ['./finish-register.component.scss'],
    standalone: false
})
export class FinishRegisterComponent extends RegisterComponent implements OnInit {
  protected jwtHelper = new JwtHelperService();
  registerCommand = new FinishRegisterUserCommand();

  public override ngOnInit(): void {
    this.loadAnreden();

    this.route.queryParams.subscribe((params) => {
      try {
        let token = atob(params.token);
        let decodedToken: any = this.jwtHelper.decodeToken(token);

        this.registerCommand.verificationToken = token;
        this.registerCommand.email = decodedToken.email;

        this.registrationForm.controls.anredeId.setValue(decodedToken.anredeid);
        this.registrationForm.controls.titelId.setValue(decodedToken.titelid);
        this.registrationForm.controls.vorname.setValue(decodedToken.firstname);
        this.registrationForm.controls.nachname.setValue(decodedToken.lastname);
        this.registrationForm.controls.email.setValue(decodedToken.email);

        this.registrationForm.controls.anredeId.disable();
        this.registrationForm.controls.titelId.disable();
        this.registrationForm.controls.vorname.disable();
        this.registrationForm.controls.nachname.disable();

        if (decodedToken.doubleOptinCompleted == true) {
          this.isPasswordFieldVisible = false;
        }
      } catch (error) {
        this.router.navigateByUrl("/authentication/preregister");
        throw error;
      }
    });

    this.languageSubscription = this.languageService.languageChanged$.subscribe(() => {
      this.loadAnreden();
    });
  }

  protected override createForm() {
    this.registrationForm = this.formBuilder.group({
      anredeId: ['', []],
      titelId: ['', []],
      email: ['', [Validators.required, emailValidator]],
      passwort: ['', [Validators.required, Validators.minLength(8), new PasswordValidator(this.languageService, this.portalkonfiguration.strongPasswordPolicy, ["email"])]],
      vorname: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      nachname: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      passwortWiederholen: ['', [Validators.required]],
      datenschutz: ['', [Validators.requiredTrue]],
      captchaChallengeResponse: ['']
    }, { validators: PasswordMatchValidator("passwort", "passwortWiederholen") });
  }

  protected get isRegistrationButtonDisabled(): boolean {
    if (this.isPasswordFieldVisible) {
      return this.registrationForm.invalid || this.isLoading;
    }
    return !this.registrationForm.controls.datenschutz.value || this.isLoading;
  }

  public override register() {
    this.registerCommand.password = this.registrationForm.controls.passwort.value;
    this.registerCommand.scope = this.authenticationConfig.scope;
    this.registerCommand.sprache = this.languageService.GetCurrLanguageAsEnum();
    this.registerCommand.captchaChallengeResponse = this.registrationForm.controls.captchaChallengeResponse.value;
    
    this.registerSubscription = this.authenticationService.apiAuthenticationFinishRegisterPost(this.registerCommand.AsRequestBody())
      .pipe(map(idToken => {
        if (idToken)
          this.authenticationService.saveIdToken(new IdToken(idToken));

        return;
      }))
      .pipe(finalize(() => {
        sessionStorage.removeItem("VerificationToken");
        this.registrationForm.markAsPristine();
      }))
      .subscribe(result => {
        let promise = this.router.navigateByUrl(this.authenticationConfig.defaultRedirectUrl);

      this.loadingAnimationService.showSpinnerUsingPromise(promise);
    });

    this.loadingAnimationService.showSpinnerUsingSubscription(this.registerSubscription);
  }
}
